<template>
  <div id="modalDetail">
    <div
      id="modal-idea-product-detail"
      class="modal fade show"
      tabindex="-1"
      role="dialog"
      style="display: block; background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content" ref="modalContent">
          <div class="modal-header bg-blue-3 rounded-0">
            <h5 class="modal-title text-center text-white mx-auto">
              FİKİR DETAYI
            </h5>
            <button type="button" class="close" @click="close">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div class="container mb-3 mw-100">
            <div class="printToPdf">
              <div class="row pl-3 pl-sm-5 modal-bar">Fikir Bilgileri</div>
              <dl class="row px-3 px-sm-5 pt-3 mb-0">
                <dt>Fikir No</dt>
                <dd>{{ detailData.SuggestionNumber }}</dd>

                <dt>Şirket</dt>
                <dd>{{ detailData.CompanyName }}</dd>

                <dt>Fikri Yapan</dt>
                <dd class="text-uppercase">
                  {{ detailData.CreatedCustomerName }} (
                  {{ detailData.CreatedCustomerCompanyName }} )
                </dd>

                <dt>Bölge</dt>
                <dd>{{ detailData.OfficeLocation }}</dd>

                <dt>Fikir Tarihi</dt>
                <dd>
                  {{ detailData.SuggestionDate | newDateFormatterFilter }}
                </dd>

                <dt>Fikir Sahibi Departman</dt>
                <dd>{{ detailData.CreatedCustomerDepartment }}</dd>

                <dt>Statü</dt>
                <dd>
                  {{ detailData.SuggestionStatusName }}
                </dd>

                <dt>Fikir Sahibi Bölüm</dt>
                <dd>{{ detailData.CreatedCustomerSection }}</dd>

                <dt v-if="detailData.SuggestionTypeId != 3">Değer Akımı</dt>
                <dd v-if="detailData.SuggestionTypeId != 3" class="single">
                  {{ detailData.ValueCurrentName }}
                </dd>
              </dl>

              <dl class="row px-3 px-sm-5 pt-3 mb-0">
                <dt>Proje Adı</dt>
                <dd class="single">{{ detailData.Title }}</dd>
                <dt>Problem Tanımı (Mevcut Durum)</dt>
                <dd class="single">{{ detailData.ProblemDefinition }}</dd>
                <dt>Hedef Tanımı</dt>
                <dd class="single">{{ detailData.TargetDefinition }}</dd>
                <dt>Kapsam</dt>
                <dd class="single">{{ detailData.Scope }}</dd>
                <dt>Fırsat Tanımı (Yan Faydalar)</dt>
                <dd class="single">{{ detailData.OpportunityDefinition }}</dd>
                <dt>Departman</dt>
                <dd class="single">
                  <multiselect
                    v-model="departments"
                    tag-placeholder="Add this as new tag"
                    placeholder="Departman seçiniz"
                    label=""
                    track-by=""
                    :options="departmentsData"
                    :multiple="true"
                    :searchable="true"
                    style="padding: 0"
                    selectLabel="Seçmek için tıklayınız"
                    selectedLabel="Seçildi"
                    deselectLabel="Silmek için tıklayınız"
                  >
                  </multiselect>
                </dd>
                <dt>Bölüm</dt>
                <dd class="single">
                  <multiselect
                    v-model="sections"
                    tag-placeholder="Add this as new tag"
                    placeholder="Departman seçiniz"
                    label=""
                    track-by=""
                    :options="sectionsData"
                    :multiple="true"
                    :searchable="true"
                    style="padding: 0"
                    selectLabel="Seçmek için tıklayınız"
                    selectedLabel="Seçildi"
                    deselectLabel="Silmek için tıklayınız"
                  >
                  </multiselect>
                </dd>
                <dt>Değer Akım Yöneticileri</dt>
                <dd class="single">{{ valueCurrent }}</dd>
                <dt>Ekip Liderleri</dt>
                <dd class="single">{{ teamLead }}</dd>
                <dt>Ekip Üyeleri</dt>
                <dd class="single">{{ team }}</dd>
                <dt>Proje Başlangıç Tarihi</dt>
                <dd class="single">
                  {{ detailData.ProjectStartDate | newDateFormatterFilter }}
                </dd>
                <dt>Proje Hayata Geçiş Tarihi</dt>
                <dd class="single">
                  {{ detailData.ProjectEndDate | newDateFormatterFilter }}
                </dd>
                <dt>Proje Yılı</dt>
                <dd class="single">
                  <select
                    class="form-control"
                    data-val="true"
                    data-val-number="The field Value must be a number."
                    data-val-required="The Value field is required."
                    id="drpProjectYear"
                    name="ProjectYear.Value"
                    v-model="projectYear"
                  >
                    <option
                      v-for="item in projectYearList"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select>
                </dd>
                <dt>Marka/Departman arası yayınlaştırılabilir mi?</dt>
                <dd class="single">
                  {{ detailData.Spreading ? "Evet" : "Hayır" }}
                </dd>
                <dt>
                  Projenin hayata geçirilebilmesi için IT geliştirmesi gerekli
                  mi?
                </dt>
                <dd class="single">
                  {{ detailData.ITDevolopment ? "Evet" : "Hayır" }}
                </dd>
                <dt>Eğitim Projesi midir?</dt>
                <dd class="single">
                  {{ detailData.LeanLeaderTraining ? "Evet" : "Hayır" }}
                </dd>
                <dt v-if="detailData.LeanLeaderTraining ">Eğitim Projeleri</dt>
                <dd class="single">
                  {{ detailData.TrainingProjectList }}
                </dd>
              </dl>
              <dl class="row px-3 px-sm-5 pt-3 mb-0">
                <dt>Doküman</dt>
                <dd class="single">
                  <a
                    v-if="
                      detailData.DownloadFile &&
                      detailData.DownloadFile.length > 0
                    "
                    :href="
                      'data:' +
                      detailData.DownloadFile[0].fileType +
                      ';base64,' +
                      detailData.DownloadFile[0].DownloadBinary
                    "
                    :download="
                      detailData.DownloadFile[0].Filename +
                      '.' +
                      detailData.DownloadFile[0].Extension
                    "
                    class="innovation-pdf mr-4"
                    title="Dokümanı bilgisayarınıza indirmek için tıklayın."
                    alt="Dokümanı bilgisayarınıza indirmek için tıklayın."
                    target="_blank"
                  >
                    {{ detailData.DownloadFile[0].Filename }}.{{
                      detailData.DownloadFile[0].Extension
                    }}
                    <span class="fas fa-file-download"></span>
                  </a>
                </dd>
                <dt
                  v-if="
                    detailData.ProjectPresentationDocumentFiles &&
                    detailData.ProjectPresentationDocumentFiles.length > 0
                  "
                >
                  Proje Sunum Dokümanı
                </dt>
                <dd
                  v-if="detailData.ProjectPresentationDocumentFiles[0]"
                  class="single"
                >
                  <a
                    v-if="detailData.ProjectPresentationDocumentFiles[0]"
                    :href="
                      'data:' +
                      detailData.ProjectPresentationDocumentFiles[0].fileType +
                      ';base64,' +
                      detailData.ProjectPresentationDocumentFiles[0]
                        .DownloadBinary
                    "
                    :download="
                      detailData.ProjectPresentationDocumentFiles[0].Filename +
                      '.' +
                      detailData.ProjectPresentationDocumentFiles[0].Extension
                    "
                    class="innovation-pdf mr-4"
                    title="Dokümanı bilgisayarınıza indirmek için tıklayın."
                    alt="Dokümanı bilgisayarınıza indirmek için tıklayın."
                    target="_blank"
                  >
                    {{
                      detailData.ProjectPresentationDocumentFiles[0].Filename
                    }}.{{
                      detailData.ProjectPresentationDocumentFiles[0].Extension
                    }}
                    <span class="fas fa-file-download"></span>
                  </a>
                </dd>
              </dl>

              <div class="row pl-3 pl-sm-5 mb-2 modal-bar">
                Etkileşim Bilgileri
              </div>

              <div class="row px-3 px-sm-5">
                <a
                  href="#"
                  class="article-comment-show icon-down"
                  @click="isComment = !isComment"
                  >{{ detailData.CommentCount }} Yorum</a
                >
                <span class="article-comment-like"
                  ><i class="fas fa-thumbs-up"></i
                  >{{ detailData.LikeCount }}</span
                >
                <article
                  v-if="isComment"
                  class="article-comment-container"
                  type="Suggestion"
                  objectid="718d7c1f-7dec-eb11-bacb-000d3ade7034"
                >
                  <div id="suggestiondetailcomments">
                    <div
                      id="commentdiv"
                      v-for="comment in detailData.Comments"
                      :key="comment.Id"
                    >
                      <div
                        class="article-comment"
                        id="article-comment-id"
                        style="position: static"
                      >
                        <div class="article-comment-body">
                          <img
                            v-if="comment.UserProfileImage"
                            class="article-user-img fallback-image"
                            :src="`data:image/png;base64, ${comment.UserProfileImage}`"
                            :alt="comment.UserName | getInitialsFilter"
                          />
                          <i
                            v-else
                            class="comment-user-img fallback-image"
                            :alt="comment.UserName | getInitialsFilter"
                            >{{ comment.UserName | getInitialsFilter }}</i
                          >
                          <span
                            >{{ comment.UserName }} (
                            {{ comment.CreatedCustomerCompanyName }} )</span
                          ><span
                            class="icon-clock"
                            :title="comment.CreatedOnUtc"
                            >{{ comment.CreatedOnUtc | dateDiffFilter }}</span
                          >
                          <p
                            style="
                              display: -webkit-box;
                              -webkit-box-orient: vertical;
                              overflow: hidden;
                            "
                          >
                            {{ comment.CommentText }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
              <div
                id="idea-maker-information"
                v-if="detailData.IsContinuityTrackingCompleted"
              >
                <div class="row pl-5 mb-2 modal-bar">Fikrin Sürekliliği</div>
                <dl class="row px-5 pt-3 mb-0">
                  <dt>Süreklilik Takibi Durumu</dt>
                  <dd>{{ detailData.ContinuityTrackingEvaluatorNote }}</dd>

                  <dt
                    v-if="
                      detailData.ContinuityTrackingEvaluatorNote ==
                      'Devam etmiyor'
                    "
                  >
                    Açıklama
                  </dt>
                  <dd
                    v-if="
                      detailData.ContinuityTrackingEvaluatorNote ==
                      'Devam etmiyor'
                    "
                  >
                    {{ detailData.ContinuityTrackingEvaluatorReason }}
                  </dd>
                </dl>
              </div>
              <div
                v-if="detailData.SuggestionStatusId == 2 && isLayout == 'Admin'"
              >
                <div class="row pl-3 pl-sm-5 mb-2 modal-bar">
                  Değerlendirme İşlemleri
                </div>
                <Approved
                  @save-project-progress="saveProjectProgress"
                  @suggestion-result-submit="suggestionResulSubmit"
                  :detailData="detailData"
                />
              </div>
              <div
                v-if="
                  detailData.SuggestionStatusId == 8 &&
                  detailData.IsContinuityTrackingActive &&
                  isLayout == 'Admin'
                "
              >
                <div class="row pl-3 pl-sm-5 mb-2 modal-bar">
                  Proje Sürekliliğinin Kontrolü
                </div>
                <ContinuityTracking
                  @send-continuity-tracking-update="
                    sendContinuityTrackingUpdate
                  "
                  :detailData="detailData"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  suggestionStatus,
  dateFormatter,
  getInitials,
  newDateFormatter,
  dateDiff,
  cancelReason,
  yearList,
} from "../../helpers";
import { suggestionRdService } from "../../services";
import Approved from "./Modal/Approved.vue";
import ContinuityTracking from "./Modal/ContinuityTracking.vue";
import Multiselect from "vue-multiselect";
import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
export default {
  name: "ProductizationOtoModal",
  data() {
    return {
      isComment: false,
      action: "",
      team: "",
      teamLead: "",
      valueCurrent: "",
      department: "",
      departments: [],
      sections: [],
      projectYear: "",
      projectYearList: [],
    };
  },
  components: {
    Multiselect,
    Approved,
    ContinuityTracking,
  },
  props: {
    detailData: {
      type: Object,
    },
    searchFilterData: {
      type: Object,
      default: () => {},
    },
    isLayout: {
      type: String,
      default: "",
    },
  },
  filters: {
    suggestionStatusFilter(value) {
      return suggestionStatus(value);
    },
    dateFormatterFilter(value) {
      return dateFormatter(value);
    },
    dateDiffFilter(value) {
      return dateDiff(value);
    },
    newDateFormatterFilter(value) {
      return newDateFormatter(value);
    },
    getInitialsFilter(value) {
      return getInitials(value);
    },
    cancelReasonFilter(value) {
      return cancelReason(value);
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
    departmentsData() {
      return this.$store.getters["suggestionRD/departmentsData"];
    },
    sectionsData() {
      return this.$store.getters["suggestionRD/sectionsData"];
    },
    statusByRolesProductization() {
      return this.$store.getters["suggestion/statusByRolesProductization"];
    },
  },
  async created() {
    this.projectYearList = yearList();
    const $body = document.querySelector("body");
    $body.style.overflow = "hidden";
    if (this.departmentsData.length == 0) {
      await this.$store.dispatch("suggestionRD/getDepartments");
    }
    if (this.sectionsData.length == 0) {
      await this.$store.dispatch("suggestionRD/getSections");
    }
    if (this.detailData) {
      let valueCurrentList = [];
      let teamList = [];
      let teamLeaderList = [];
      this.detailData.SuggestionRDUserModels.forEach((element) => {
        if (element.UserStatus == "4") {
          valueCurrentList.push(element.UserName);
        }
        if (element.UserStatus == "2") {
          teamList.push(element.UserName);
        }
        if (element.UserStatus == "3") {
          teamLeaderList.push(element.UserName);
        }
      });
      this.valueCurrent = valueCurrentList.join();
      this.team = teamList.join();
      this.teamLead = teamLeaderList.join();

      this.department = this.detailData.Department;
      this.departments = this.detailData.SelectedDepartments;
      this.sections = this.detailData.SelectedSections;
      this.projectYear = this.detailData.ProjectYear
        ? this.detailData.ProjectYear 
        : "";
    }
  },
  beforeMount() {
    document.addEventListener("click", this.clickOutSide);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickOutSide);
  },
  methods: {
    close() {
      this.$emit("close", false);
      const $body = document.querySelector("body");
      $body.style.removeProperty("overflow");
    },
    clickOutSide(e) {
      let el = this.$refs.modalContent;

      //Modal click outside close modal
      let target = e.target;
      if (el !== target && !el.contains(target)) {
        this.close();
      }
    },
    async updateModalAPI(tmpData) {
      delete tmpData["DownloadFile"];
      try {
        await suggestionRdService.fetchUpdateSuggestionRD(tmpData);
        this.$toast.success("Başarılı bir şekilde güncellendi.", {
          position: "top",
        });
        this.$store.dispatch("suggestion/deleteProductizationData");
        const data = this.searchFilterData;
        this.$store.dispatch("suggestion/setProductizationData", data);
        this.close();
      } catch (error) {
        this.$toast.error("Güncelleştirme başarısız.", {
          position: "top",
        });
      }
    },
    async saveProjectProgress(event) {
      const tmpData = this.detailData;
      tmpData.ProjectProgress = event;
      await this.updateModalAPI(tmpData);
    },
    async suggestionResulSubmit(event) {
      const tmpData = this.detailData;
      tmpData.SuggestionStatusId = parseInt(event.id);
      tmpData.ProjectEndDate = event.projectEndDate;
      tmpData.ProjectCancelledReason = event.projectCancelledReason;
      tmpData.ProjectCancelledDate = event.projectCancelledDate;
      tmpData.ProjectPendingReason = event.projectPendingReason;
      tmpData.PendingProcessDate = event.pendingProcessDate;
      await this.updateModalAPI(tmpData);
      if (event.callback) event.callback();
    },
    async sendContinuityTrackingUpdate(event) {
      let tmpData = {};

      for (let key in this.detailData) {
        tmpData[key] = this.detailData[key];
      }
      tmpData.ContinuityTrackingEvaluatorNote =
        event.continuityTrackingEvaluatorNote;
      tmpData.ContinuityTrackingEvaluatorReason =
        event.continuityTrackingEvaluatorReason;
      await this.updateModalAPI(tmpData);
      if (event.callback) event.callback();
    },
    async saveChange() {
      const tmpData = this.detailData;
      tmpData.Department = this.department;
      tmpData.departments = this.editPagedData.SelectedDepartments;
      tmpData.sections = this.editPagedData.SelectedSections;
      tmpData.ProjectYear = this.projectYear;
      await this.updateModalAPI(tmpData);
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/admin/styles/scss/productization.scss";
</style>
